import _typeof from "@babel/runtime/helpers/esm/typeof";
import PulldownOutlined from 'dd-icons/lib/PulldownOutlined';
import NormalFileOutlined from 'dd-icons/lib/NormalFileOutlined';
import LoadingCircle2Outlined from 'dd-icons/lib/LoadingCircle2Outlined';
import ReduceOutlined from 'dd-icons/lib/ReduceOutlined';
import AddOutlined from 'dd-icons/lib/AddOutlined';
import classNames from 'classnames';
import * as React from 'react';
import { cloneElement, isValidElement } from '../../_util/reactNode';
export default function renderSwitcherIcon(prefixCls, switcherIcon, showLine, treeNodeProps) {
  var isLeaf = treeNodeProps.isLeaf,
    expanded = treeNodeProps.expanded,
    loading = treeNodeProps.loading;
  if (loading) {
    return /*#__PURE__*/React.createElement(LoadingCircle2Outlined, {
      className: "".concat(prefixCls, "-switcher-loading-icon dtd-spin-animation")
    });
  }
  var showLeafIcon;
  if (showLine && _typeof(showLine) === 'object') {
    showLeafIcon = showLine.showLeafIcon;
  }
  if (isLeaf) {
    if (!showLine) {
      return null;
    }
    if (typeof showLeafIcon !== 'boolean' && !!showLeafIcon) {
      var leafIcon = typeof showLeafIcon === 'function' ? showLeafIcon(treeNodeProps) : showLeafIcon;
      var leafCls = "".concat(prefixCls, "-switcher-line-custom-icon");
      if (isValidElement(leafIcon)) {
        return cloneElement(leafIcon, {
          className: classNames(leafIcon.props.className || '', leafCls)
        });
      }
      return leafIcon;
    }
    return showLeafIcon ? ( /*#__PURE__*/React.createElement(NormalFileOutlined, {
      className: "".concat(prefixCls, "-switcher-line-icon")
    })) : ( /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-switcher-leaf-line")
    }));
  }
  var switcherCls = "".concat(prefixCls, "-switcher-icon");
  var switcher = typeof switcherIcon === 'function' ? switcherIcon(treeNodeProps) : switcherIcon;
  if (isValidElement(switcher)) {
    return cloneElement(switcher, {
      className: classNames(switcher.props.className || '', switcherCls)
    });
  }
  if (switcher) {
    return switcher;
  }
  if (showLine) {
    return expanded ? ( /*#__PURE__*/React.createElement(ReduceOutlined, {
      className: "".concat(prefixCls, "-switcher-line-icon")
    })) : ( /*#__PURE__*/React.createElement(AddOutlined, {
      className: "".concat(prefixCls, "-switcher-line-icon")
    }));
  }
  return /*#__PURE__*/React.createElement(PulldownOutlined, {
    className: switcherCls
  });
}